module.exports = __webpack_public_path__ + "img/011.95018deb.jpg";